(ns minorodata.components.pipeline-editor.routes
  "Route vectors for the pipeline editor. Building one is separate from
   navigating to it, so the shapes can be asserted without the editor.")


(defn extract-edit-route [source-id extract-id]
  [:extract-details {:source-id source-id :extract-id extract-id} {:tab "edit"}])


(defn extract-legacy-route [source-id extract-id]
  [:extract-details {:source-id source-id :extract-id extract-id}])
